module.exports = __webpack_public_path__ + "img/section32.8c0f3292.png";